define('gameday-index-component-base/GDIndexComponentBase',['require','exports','module','es6ish-class/es6ish-class'],function(require,exports,module) {
	var Classifier = require("es6ish-class/es6ish-class");

	function GdiComponentBase(compID, divID) { }

	GdiComponentBase.prototype = {
		initialized: false,
		targetDiv: null,
		componentID: null,

		init: function(compID, divID) {
			this.componentID = compID;
			this.targetDiv = divID || "#fart";
		}
	};

	Classifier(GdiComponentBase);
	return GdiComponentBase;
});
